/*
 * File: error-code-common.ts
 * Created: 2026-03-02 14:41:11
 * Author: Val Liu <valuis0429@gmail.com>
 * -----
 * Last Modified: 2026-03-02 15:05:41
 * Modified By: Val Liu <valuis0429@gmail.com>
 */

import { QuickHelper } from "@root/core/utilities/quick-helper";
import { lang } from "@root/core/i18n";

export type GlobalErrorMessage = {
    key: string;
    params?: any[];
};

type GlobalErrorContext = {
    uri?: string;
    method?:
        | "C"
        | "R"
        | "U"
        | "D"
        | "detail"
        | "GET"
        | "POST"
        | "PUT"
        | "PATCH"
        | "DELETE";
};

function normalizeMethod(
    method?: GlobalErrorContext["method"],
): "C" | "R" | "U" | "D" | "detail" | undefined {
    if (!method) return undefined;
    const upper = String(method).toUpperCase();
    switch (upper) {
        case "C":
        case "POST":
            return "C";
        case "R":
        case "GET":
        case "PATCH":
            return "R";
        case "U":
        case "PUT":
            return "U";
        case "D":
        case "DELETE":
            return "D";
        case "DETAIL":
            return "detail";
        default:
            return undefined;
    }
}

export function resolveGlobalErrorMessage(
    code?: string | null,
    context?: GlobalErrorContext,
    fields?: string[],
): GlobalErrorMessage | null {
    if (!code) return null;
    const raw = String(code).trim();
    if (!raw) return null;

    if (/^unique_constraint$/i.test(raw)) {
        const field = fields?.[0];
        if (field && context?.uri) {
            const normalized = normalizeMethod(context.method);
            const labelKey = QuickHelper.resolveUILabelKeyByUri(context.uri, field, {
                method: (normalized ?? context.method) as any,
            });
            const label = labelKey ? lang.translate(labelKey as any) : field;
            return { key: "e_UNIQUE_CONSTRAINT_FIELD", params: [label] };
        }
        return { key: "e_UNIQUE_CONSTRAINT" };
    }

    return null;
}
